<template>
  <div>
    <div class="ui info message" style="display: block">
      <div class="header">{{ $t("hints") }}</div>
      <ul class="list">
        <li
          v-html="
            $t(
              'after making any change in any file, in order for the change to take effect, you must reload api environment.',
            )
          "
        ></li>
      </ul>
    </div>
    <generic-container
      :title="$t('file list')"
      icon="file"
      :searchable="true"
      v-on:filter="filter"
      :show_refresh="true"
      @refresh="getData"
      :show_plus="true"
      @add="add"
      :header_buttons="header_buttons"
    >
      <div class="ui grid">
        <div class="six column row" style="padding: 40px 0">
          <div
            class="column"
            v-for="(file, index) in files"
            :key="index"
            style="text-align:center; padding: 10px 0"
          >
            <div class="ui icon header" @click="edit(file, index)">
              <i class="js file square icon"></i>
              <div class="content">
                <a href="#">{{ file.file_name }}</a>
                <div class="sub header" v-if="file.stat">
                  {{
                    file.stat.mtime
                      | formatDate(enterprise_setup.detailed_date_format)
                  }}
                </div>
                <div class="sub header" v-if="file.stat">
                  {{ file.stat.size | sizeFromKB }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </generic-container>

    <template v-for="(mdl, index) in file_modals">
      <component
        :is="mdl"
        :key="index"
        :file_in="selected_file"
        @succedded="succedded"
        @destroy="destroy"
        @deleted="deleted"
      ></component>
    </template>
  </div>
</template>

<script>
import {
  local_api,
  error_toast,
  enterprise_setup,
  success_toast,
} from "@/utils";
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import { isEmpty, clone } from "lodash";
import FileModal from "./file_modal/Index";

// @ is an alias to /src
export default {
  name: "CodeFiles",
  components: {
    "generic-container": GenericContainer,
  },
  filters: filters,
  data() {
    return {
      all_files: [],
      files: [],
      header_buttons: [
        {
          icon: "red recycle",
          click: this.reload,
          tooltip: this.$t("reload api environment"),
        },
      ],
      file_modals: [],
      selected_file: undefined,
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    filter(value) {
      if (value == "") this.files = this.all_files;
      else
        this.files = this.all_files.filter((e) => {
          return e.file_name.toUpperCase().includes(value.toUpperCase());
        });
    },
    add() {
      this.file_modals.push(FileModal);
    },
    edit(file) {
      this.selected_file = file;
      this.file_modals.push(FileModal);
    },
    succedded() {
      this.getData();
      // let idx = this.files.findIndex((e) => e.file_name == file);
      // if (idx >= 0) this.files.splice(idx, 1, { file_name: file });
      // else this.files.push(file);
      // this.selected_file = undefined;
    },
    destroy() {
      this.selected_file = undefined;
      this.file_modals = [];
    },
    isEmpty: isEmpty,
    getData() {
      let vm = this;
      local_api(vm, "post", "/api_manager/do-get-files")
        .then((files) => {
          vm.files = files;
          vm.all_files = clone(files);
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    deleted() {
      this.getData();
      // let idx = this.files.findIndex((r) => r.uuid == p.uuid);
      // if (idx >= 0) this.files.splice(idx, 1);
      // this.destroy();
    },
    reload() {
      let vm = this;
      local_api(vm, "post", "/api_manager/do-reload")
        .then(() => {
          success_toast(vm.$t("api environment reloaded"));
        })
        .catch((err) => {
          error_toast(err);
        });
    },
  },
  mounted() {
    this.getData();
  },
  watch: {},
};
</script>
